import { render, staticRenderFns } from "./CardAdvanceBussinessSharks.vue?vue&type=template&id=37b96aa9&"
import script from "./CardAdvanceBussinessSharks.vue?vue&type=script&lang=js&"
export * from "./CardAdvanceBussinessSharks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports